import React, { useState, useEffect, useMemo, useRef } from "react";
import { useTable, useGlobalFilter } from 'react-table';
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchdataprocess,Fetchheaderdata, Fetchupdatequery,FetchReadfile,FetchReadmail } from '../../../services/process/BRS1/brsService7';
import { CreateData } from '../../../services/process/process_data/process_data';
import { Icon,Grid } from 'semantic-ui-react';
import '../css/reconSummary.css';
import Select from "react-select";
import EditIcon from '@mui/icons-material/Edit';
import excelIcon from '../../../assets/images/excel.png';
import FilePreviewer from "../common/file_displayer";

function PurchaseRequirement() {
  const [formData, setFormData] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.selectedentity,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  const [formData1, setFormData1] = useState([]);
  const [formData2, setFormData2] = useState([{}]);
  const [formData3, setFormData3] = useState([]);
  const [formData4, setFormData4] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [tablerowData, settableRowData] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [fields, setFields] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [columnDefs, setColumnDefs] = useState([]);
  const [tablecolumnDefs, settableColumnDefs] = useState([]);
  const [fields1, setFields1] = useState(null);
  const [columnDefs1, setColumnDefs1] = useState([]);
  const [fields2, setFields2] = useState([]);
  const [columnDefs2, setColumnDefs2] = useState([]);
  const [fields3, setFields3] = useState(null);
  const [columnDefs3, setColumnDefs3] = useState([]);
  const [fields4, setFields4] = useState(null);
  const [columnDefs4, setColumnDefs4] = useState([]);
  const [prfno, setPrfno] = useState('');
  const [manager, setManager] = useState('');
  const [section2Rows, setSection2Rows] = useState([{}]);
  const [section3Rows, setSection3Rows] = useState([{}]);
  const [unMatchedHidden, setUnMatchedHidden] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');
  const [remarks, setRemarks] = useState("");
  const [createHidden, setCreateHidden] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const [quotations, setQuotations] = useState([{ id: 1, label: "Quotation 1" }]);
  const [selectedQuotationId, setSelectedQuotation] = useState(0);
  const [quotationData, setQuotationData] = useState([]);
  const [options, setOptions] = useState([]);
  const [quotationinputData, setQuotationinputData] = useState([]);
  const [selectedvalue, setSelectedvalue] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const baseUrl = "http://172.16.40.13:1201/static/";

  // State to control collapsibility of divs
  const [isDiv1Open, setIsDiv1Open] = useState(true);
  const [isDiv2Open, setIsDiv2Open] = useState(true);
  const [isDiv3Open, setIsDiv3Open] = useState(true);
  const [isDiv4Open, setIsDiv4Open] = useState(true);
const [gridApi, setGridApi] = useState(null);

const onGridReady = (params) => {
  setGridApi(params.api);
};


  useEffect(() => {
    fetchFieldInfo(87, setFields, setColumnDefs);
    fetchFieldInfo(94, setFields2, setColumnDefs2);
    fetchFieldInfo(90, setFields3, setColumnDefs3);
    fetchFieldInfo(93, setFields4, setColumnDefs4);
    fetchprfTableInfo1();
    fetchtabledetailsInfo();
    console.log(userCredentials)
  }, []);

const handleSubmit = async (e) => {
  e.preventDefault(); // Prevent form default submission behavior
  console.log("form data",e)
};

const gridRef = useRef();

const onBtnExportCSV = () => {
const tabLabel = tabConfig[activeTab]?.title || 'Invoices';
  gridRef.current.api.exportDataAsCsv({
    fileName: `Approver_${tabLabel}_invoices.csv`, // <-- Set your desired file name here
    columnKeys: tablecolumnDefs
      .filter(col => !col.checkboxSelection)
      .map(col => col.field),
    processCellCallback: (params) => params.value ?? '',
  });
};


  const tabConfig = [
    { title: "Folder Reading", key: "New" },
    { title: "Mail Reading", key: "Hold" },
  ];


const handleRemarksChange = (e) => {
  setRemarks(e.target.value);
};

const readFilesService = async () => {
  const payload = {}; // backend does not require input

  try {
    // 👇 use FetchReadfile instead
    const FileReadCredentials = FetchReadfile();

    const response = await axios.post(
      FileReadCredentials[1],   // API URL
      payload,
      FileReadCredentials[0]    // headers/config
    );

    const data = response.data;
    console.log("File Read Response:", data);

    // -------- ALERT LOGIC --------
    if (data.status === "SUCCESS") {
      alert(`✅ ${data.summary.files_processed} files read successfully`);
    }

    else if (data.status === "PARTIAL_SUCCESS") {
      alert(
        `⚠️ ${data.summary.files_processed} files processed, ` +
        `${data.summary.files_failed} failed`
      );
    }

    else if (data.status === "NO_FILES") {
      alert("ℹ️ No files found to process");
    }

    else {
      alert("❌ File processing failed");
    }

    return data;

  } catch (error) {
    console.error("File read error:", error);
    alert("❌ Server error while reading files");
    return null;
  }
};


const readMailsService = async () => {
  const payload = {}; // backend does not require input

  try {
    // 👇 use FetchReadfile instead
    const FileReadCredentials = FetchReadmail();

    const response = await axios.post(
      FileReadCredentials[1],   // API URL
      payload,
      FileReadCredentials[0]    // headers/config
    );

    const data = response.data;
    console.log("File Read Response:", data);

    // -------- ALERT LOGIC --------
    if (data.status === "SUCCESS") {
      alert(`✅ ${data.summary.attachments_saved} attachments downloaded successfully`);
    }

    else if (data.status === "PARTIAL_SUCCESS") {
      alert(
        `⚠️ ${data.summary.attachments_saved} attachments downloaded.\n` +
        `${data.summary.failed} emails failed to process.`
      );
    }

    else if (data.status === "NO_MAILS") {
      alert("ℹ️ No matching emails found.");
    }

    else if (data.status === "ERROR") {
      alert("❌ Mail processing failed. Please check logs.");
    }


    return data;

  } catch (error) {
    console.error("File read error:", error);
    alert("❌ Server error while reading files");
    return null;
  }
};

const processData = async () => {

  const payload = {}; // backend does not require input

  try {
    const FileReadCredentials = Fetchdataprocess();

    const response = await axios.post(
      FileReadCredentials[1],
      payload,
      FileReadCredentials[0]
    );

    const data = response.data;

    console.log("File Read Response:", data);

    // ✅ SUCCESS CASE
    if (response.status === 200 && data === "ok") {
      alert("✅ File processed successfully");
      return data;
    }

    // fallback
    alert(data);
    return data;

  } catch (error) {

    console.error("File read error:", error);

    // ✅ BACKEND ERROR MESSAGE
    if (error.response && error.response.data) {
      alert(`❌ ${error.response.data}`);
    } else {
      alert("❌ Server error while reading files");
    }

    return null;
  }
};

const getFileDataRequired = (responseData) => {
    const dataValues = responseData;
    const requiredFileData = {};

    for (const key in dataValues) {
      if (key.startsWith("file_") && key.endsWith("_type")) {
        const fileTypeValue = dataValues[key];
        const fileIndex = key.split("_")[1]; // Extract the index (e.g., '1' from 'file_1_type')
        if (fileTypeValue.length > 0) {
          const filePath = dataValues[`file_${fileIndex}_path`];
          requiredFileData[`file_${fileIndex}`] = {
            type: fileTypeValue,
            path: filePath,
          };
        }
      }
    }

    return requiredFileData;
  };


    // Helper function to format date
  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const enhanceRowsWithCommonFields = (rows, commonFields) =>
    rows.map(row => ({ ...row, ...commonFields }));

  // Helper function to create payload
  const createPayload = (database, table, formData) => ({
    database,
    table,
    formData,
  });

  // Helper function for Axios requests
  const makeApiRequest = (url, payload, headers) => {
    return axios.post(url, payload, headers)
      .then(response => {
        console.log("API Response:", response);
      })
      .catch(error => {
        console.error("API Error:", error);
        throw new Error("Error with API call");
      });
  };


  const fetchFieldInfo = async (headerConfigId, setFieldsFunc, setColumnDefsFunc) => {
    const payload = { headerconfig_id: headerConfigId, "filterconditions": filterconditions };
  
    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], 
        payload, 
        FileUploadCredentials[0]
      );
  
      const data = response.data;
      console.log("fetched data",data)

      if (data.fields?.length) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        }));
  
        setColumnDefsFunc(columns);
        setFieldsFunc(data.fields);
        console.log("updation completed")
        return { fields: data.fields };
      }
    } catch (error) {
      console.error(`Error fetching field info for headerConfigId ${headerConfigId}:`, error);
      setError("Error fetching fields data");
        return { fields: []};
    }
  };
    

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  

const fetchprfTableInfo1 = async () => {
  const payload = { headerconfig_id: 95, "filterconditions": filterconditions };

  try {
    const FileUploadCredentials = Fetchheaderdata(); // Function to fetch header data
    const response = await axios.post(
      FileUploadCredentials[1], // URL
      payload,                  // Payload
      FileUploadCredentials[0]  // Headers or Credentials
    );

    const data = response.data;
    if (data.fields && data.fields.length > 0) {
      // Map the fields to columns
      const columns = data.fields.map((field) => ({
        headerName: formatColumnName(field.columnName),
        field: field.columnName,
        sortable: true,
        filter: true,
        resizable: true,
        width: 200,
      }));

      // Define the "Select" column
      const selectColumn = {
        headerName: "",
        checkboxSelection: true,
headerCheckboxSelection: true,
headerCheckboxSelectionFilteredOnly: true,
        width: 50,
        pinned: "left", // Optional: pin the column to the left for better visibility
      };


      // Add the "Select" column as the first column
      columns.unshift(selectColumn);

      console.log("Table Column Definitions:", columns);
      settableColumnDefs(columns); // Update state with column definitions
    }
  } catch (error) {
    console.error("Error fetching field info:", error);
    setError("Error fetching fields data");
  } finally {
    setLoading(false); // Ensure loading state is updated even in case of an error
  }
};

const fetchprfTableInfo2 = async () => {
  const payload = { headerconfig_id: 96, "filterconditions": filterconditions };

  try {
    const FileUploadCredentials = Fetchheaderdata(); // Function to fetch header data
    const response = await axios.post(
      FileUploadCredentials[1], // URL
      payload,                  // Payload
      FileUploadCredentials[0]  // Headers or Credentials
    );

    const data = response.data;
    if (data.fields && data.fields.length > 0) {
      // Map the fields to columns
      const columns = data.fields.map((field) => ({
        headerName: formatColumnName(field.columnName),
        field: field.columnName,
        sortable: true,
        filter: true,
        resizable: true,
        width: 200,
      }));

      // Define the "Select" column
      const selectColumn = {
        headerName: "",
        checkboxSelection: true,
headerCheckboxSelection: true,
headerCheckboxSelectionFilteredOnly: true,
        width: 50,
        pinned: "left", // Optional: pin the column to the left for better visibility
      };


      // Add the "Select" column as the first column
      columns.unshift(selectColumn);

      console.log("Table Column Definitions:", columns);
      settableColumnDefs(columns); // Update state with column definitions
    }
  } catch (error) {
    console.error("Error fetching field info:", error);
    setError("Error fetching fields data");
  } finally {
    setLoading(false); // Ensure loading state is updated even in case of an error
  }
};
  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

  const navigate = (direction) => {
    if (direction === 'next' && currentIndex < options.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else if (direction === 'prev' && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };


const addRow2 = () => {
  setFormData2((prev) => [...prev, {}]);
};


const deleteRow2 = (index) => {
  setFormData2((prev) => {
    if (prev.length === 1) return prev; // prevent deleting last row
    return prev.filter((_, i) => i !== index);
  });
};


  const getFileType = (filePath) => {
    const extension = "pdf"; // Get the file extension
    if (extension === 'pdf') {
      return 'pdf';
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
      return 'image';
    }
    return 'unsupported';
  };


  const [currentIndex, setCurrentIndex] = useState(0);
  const currentFile = options[currentIndex]?.value || null;
  const fileType =  currentFile ? getFileType(currentFile.path) : null;

  const handleClick = () => {
if (!selectedRow || selectedRow.length !== 1) {
  alert("Please select one row before clicking.");
  return; // stop further execution
}

   BrsTypeList();
   setCurrentIndex(0);
   fetchinvformdetails();
   setUnMatchedHidden(true);
   setCreateHidden(false);

  };

const handleApproverClick = async () => {
    const formattedDate = getFormattedDate();
  if (!selectedRow || selectedRow.length === 0) {
    alert("Please select one row before clicking.");
    return; // stop further execution
  }
  const payload = {
    schema_name: "payments",
    table: "approved_invoices",
    set_column: {
      is_approver_approved: 1,is_approver_rejected: 0,is_approver_hold: 0,approver_reject_comments :"",approver_hold_comments:"",
      invoice_status: "SENT TO FINANCE",approver_approval_date: formattedDate
    },
    where: [{ id : selectedRow.map((row) => (row.id )) }],
  };
  try {
    const FileUploadCredentials = Fetchupdatequery();
    const response = await axios.post(
      FileUploadCredentials[1],
      payload,
      FileUploadCredentials[0]
    );

    if (response.status === 200) {
      alert("Invoices approved successfully.");
gridApi.deselectAll();
fetchtabledetailsInfo();
    } else {
      alert("Something went wrong. Please try again.");
    }
    setRemarks("")
    console.log("response", response);
  } catch (error) {
    console.error("Error approving invoice:", error);
    setError("Error approving invoice");
    alert("Failed to approve invoice.");
  }
};

const handleHoldClick = async () => {
    const formattedDate = getFormattedDate();
  if (!selectedRow || selectedRow.length === 0) {
    alert("Please select one row before clicking.");
    return; // stop further execution
  }
  const payload = {
    schema_name: "payments",
    table: "approved_invoices",
    set_column: {
      is_approver_approved: 0,is_approver_rejected: 0,is_approver_hold: 1,approver_hold_comments :remarks,approver_reject_comments:"",
      invoice_status: "HOLD BY APPROVER",approver_approval_date: formattedDate
    },
    where: [{ id: selectedRow[0].id }],
  };
  try {
    const FileUploadCredentials = Fetchupdatequery();
    const response = await axios.post(
      FileUploadCredentials[1],
      payload,
      FileUploadCredentials[0]
    );

    if (response.status === 200) {
      alert("Invoices Kept on Hold successfully.");
gridApi.deselectAll();
fetchtabledetailsInfo();
    } else {
      alert("Something went wrong. Please try again.");
    }
    setRemarks("")
    console.log("response", response);
  } catch (error) {
    console.error("Error approving invoice:", error);
    setError("Error approving invoice");
    alert("Failed to approve invoice.");
  }
};

const handleRejectClick = async () => {
    const formattedDate = getFormattedDate();
  if (!selectedRow || selectedRow.length === 0) {
    alert("Please select one row before clicking.");
    return; // stop further execution
  }
  const payload = {
    schema_name: "payments",
    table: "approved_invoices",
    set_column: {
      is_approver_approved: 0,is_approver_rejected: 1,is_approver_hold: 0,approver_reject_comments :remarks,approver_hold_comments:"",
      invoice_status: "REJECTED BY APPROVER",approver_approval_date: formattedDate
    },
    where: [{ id: selectedRow[0].id }],
  };
  try {
    const FileUploadCredentials = Fetchupdatequery();
    const response = await axios.post(
      FileUploadCredentials[1],
      payload,
      FileUploadCredentials[0]
    );

    if (response.status === 200) {
      alert("Invoices Rejected successfully.");
      gridApi.deselectAll();
fetchtabledetailsInfo();
    } else {
      alert("Something went wrong. Please try again.");
    }
    setRemarks("")
    console.log("response", response);
  } catch (error) {
    console.error("Error approving invoice:", error);
    setError("Error approving invoice");
    alert("Failed to approve invoice.");
  }
};


  const handleClick1 = () => {
   setFormData1([]);
   setFormData2([{}]);
   setFormData3([]);
   setFormData4([]);
   fetchtabledetailsInfo();
gridApi.deselectAll();
setSelectedRow(null); // clear your state too

   setUnMatchedHidden(false);
   setCreateHidden(true);
  };


  const fetchtabledetailsInfo = async () => {
        setLoading(true);
  const formatted = userCredentials.division.join(",");
  console.log("activeTab",activeTab);
    setSearchText("");
    setRemarks("")
  let condition = "folder_files";

  if (activeTab === 1) {
    condition = "mail_attachments";
    fetchprfTableInfo2();
  } else {
    fetchprfTableInfo1();
  }

    const payload = { query: `SELECT * FROM bct_ap_poc.${condition};` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
        settableRowData([]);
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        settableRowData(data);
        setLoading(false);
      }
        setLoading(false);

    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
        settableRowData(null);
        setLoading(false);
    }
  };
  useEffect(() => {
    fetchtabledetailsInfo();
  }, [activeTab]);


  const fetchinvformdetails = async () => {
    
    const payload = { query: `SELECT *
FROM bct_ap_poc.inv_field g
LEFT JOIN bct_ap_poc.po_header p
  ON g.po_id = p.po_id
LEFT JOIN bct_ap_poc.grp_details gd
  ON g.grp_id = gd.grp_id
WHERE p.po_id = ${selectedRow[0].po_id} and g.inv_id = ${selectedRow[0].inv_id} and gd.grp_id = ${selectedRow[0].grp_id};
;` };
    const payload_1 = { query: `select * from bct_ap_poc.inv_item where inv_id = ${selectedRow[0].inv_id};` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;

      const response_1 = await axios.post(
        FileUploadCredentials[1],
        payload_1,
        FileUploadCredentials[0]
      );

      const data_1 = response_1.data;


if (Array.isArray(data) && data.length > 0) {
  setFormData(data[0]);
  setFormData3(data[0]);
  setFormData4(data[0]);

} else {
  setFormData([]); // or setFormData({}) depending on your default
  setFormData3([]);
  setFormData4([]);
}

console.log("data_1",data)

if (Array.isArray(data_1) && data_1.length > 0) {
  setFormData2(data_1);

} else {
  setFormData2([{}]); // or setFormData({}) depending on your default
}

    } catch (error) {
      console.error("Error fetching invoice data:", error);
      setError("Error fetching invoice data");
    }
  };
// Helper to convert DD-MM-YYYY to MySQL DATETIME
const convertToMySQLDateTime = (dateStr) => {
  if (!dateStr) return null;
  const [day, month, year] = dateStr.split('-');
  const date = new Date(`${year}-${month}-${day}T00:00:00`);
  // Format to YYYY-MM-DD HH:MM:SS
  const pad = (n) => n.toString().padStart(2, '0');
  const formatted = `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  return formatted;
};


const handleDeleteClick = async () => {
  // Ask for confirmation
  const confirmDelete = window.confirm("Are you sure you want to delete?");
  if (!confirmDelete) return; // Stop if user cancels

  try {
    const update_payload_1 = {
      schema_name: "payments",
      table: "purchase_order_mapped",
      set_column: { is_active: 0 },
      where: [{ id: selectedRow[0].id }],
    };
    const FileUploadCredentials_1 = Fetchupdatequery();
    await axios.post(FileUploadCredentials_1[1], update_payload_1, FileUploadCredentials_1[0]);
    fetchtabledetailsInfo();
    alert("Deleted successfully ?");

  } catch (error) {
    console.error("Error deleting row:", error);
    alert("Failed to delete. Please try again ?");
  }
};



async function BrsTypeList() {
  try {
    if (!selectedRow?.length) return;

    const poId = Number(selectedRow[0].inv_id);

    const payload = {
      query: `SELECT attachment_name FROM bct_ap_poc.inv_field WHERE inv_id = ${poId};`
    };

    const creds = Fetchexecutequery();
    const response = await axios.post(creds[1], payload, creds[0]);

    const data = response.data || [];

    // Extract filenames (plain strings)
    const files = data
      .map(row => row.attachment_name)
      .filter(Boolean); // remove null/empty

    // Convert to dropdown options
    const formattedOptions = files.map((file, index) => ({
      label: file,   // display filename
      value: file,   // value passed on select
      key: index
    }));

    setOptions(formattedOptions);

  } catch (error) {
    console.error("Error fetching attachment list:", error);
  }
}



  const handleInputChange = (name, value) => {
    console.log("formdata",formData)
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

const handleInputChange12352 = (index, name, value) => {
  console.log(index, name, value);
  setFormData2((prev) => {
    const updated = [...prev];
    updated[index] = { ...updated[index], [name]: value };
    return updated;
  });
};
const handleInputChange2 = (index, name, value) => {
  console.log(index, name, value);
  setFormData2((prev) => {
    const updated = [...prev];
    let row = { ...updated[index] };

    const percentValue = Number(value) || 0;
    const quantity = Number(row.quantity) || 0;
    const rate = Number(row.rate_per_unit) || 0;
    let line_amount = Number(row.line_amount) || 0;

    // --- GST logic ---
    if (name === "line_sgst_percent") {
      row.line_sgst_percent = percentValue;
      row.line_cgst_percent = percentValue;
      row.line_igst_percent = 0;

      row.line_sgst_amount = (line_amount * percentValue) / 100;
      row.line_cgst_amount = (line_amount * percentValue) / 100;
      row.line_igst_amount = 0;
    } else if (name === "line_cgst_percent") {
      row.line_sgst_percent = percentValue;
      row.line_cgst_percent = percentValue;
      row.line_igst_percent = 0;

      row.line_sgst_amount = (line_amount * percentValue) / 100;
      row.line_cgst_amount = (line_amount * percentValue) / 100;
      row.line_igst_amount = 0;
    } else if (name === "line_igst_percent") {
      row.line_sgst_percent = 0;
      row.line_cgst_percent = 0;
      row.line_igst_percent = percentValue;

      row.line_sgst_amount = 0;
      row.line_cgst_amount = 0;
      row.line_igst_amount = (line_amount * percentValue) / 100;
    }

    // --- Amount logic (quantity * rate_per_unit) ---
    if (name === "quantity" || name === "rate_per_unit") {
      const newQuantity = name === "quantity" ? Number(value) || 0 : quantity;
      const newRate = name === "rate_per_unit" ? Number(value) || 0 : rate;
      row.quantity = newQuantity;
      row.rate_per_unit = newRate;

      row.line_amount = newQuantity * newRate;
      line_amount = row.line_amount; // update local amount for GST calculations

      // Recalculate GST amounts with updated amount
      if (row.line_sgst_percent || row.line_cgst_percent) {
        row.line_sgst_amount = (row.line_amount * row.line_sgst_percent) / 100;
        row.line_cgst_amount = (row.line_amount * row.line_cgst_percent) / 100;
      }
      if (row.line_igst_percent) {
        row.line_igst_amount = (row.line_amount * row.line_igst_percent) / 100;
      }
    } else if (
      name !== "line_sgst_percent" &&
      name !== "line_cgst_percent" &&
      name !== "line_igst_percent"
    ) {
      // Normal update
      row[name] = value;
    }

    // --- Calculate total line amount ---
row.amount = Number(
  (
    (Number(row.line_amount) || 0) +
    (Number(row.line_sgst_amount) || 0) +
    (Number(row.line_cgst_amount) || 0) +
    (Number(row.line_igst_amount) || 0)
  ).toFixed(2)
);

    updated[index] = row;

    // --- Calculate totals across all rows ---
    const totals = updated.reduce(
      (acc, r) => {
        acc.invoice_amount += Number(r.line_amount) || 0;
        acc.sgst_amount += Number(r.line_sgst_amount) || 0;
        acc.cgst_amount += Number(r.line_cgst_amount) || 0;
        acc.igst_amount += Number(r.line_igst_amount) || 0;
        acc.total_invoice_amount += Number(r.amount) || 0;
        return acc;
      },
      {
        invoice_amount: 0,
        sgst_amount: 0,
        cgst_amount: 0,
        igst_amount: 0,
        total_invoice_amount: 0,
      }
    );

    // --- Push totals to formData3 ---
    setFormData3((prev3) => ({
      ...prev3,
      ...totals,
    }));

    return updated;
  });
};


  const handleInputChange3 = (name, value) => {
    console.log("formdata4",formData4)
    setFormData4((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const validateField = (value, type) => {
      if (!type) return true; // If no type is defined, skip validation

      switch (type.value) {
          case "text":
              return true; // Allow any text input
          case "integer":
              return /^-?\d*$/.test(value); // Allow integers (positive or negative) and empty input for partial typing
          case "decimal":
              return /^-?\d*\.?\d*$/.test(value); // Allow numbers with optional decimal points
          case "date":
              return !isNaN(Date.parse(value)); // Validate as a valid date
          default:
              return true; // For unsupported types, skip validation
      }
  };


  const handleInputChange1 = (name, value, index,type) => {
    console.log("section2rows",section2Rows)
    setSection2Rows(prevRows => {
      const updatedRows = [...prevRows];
      const isValid = validateField(value, type);
      if (!isValid) {
        console.warn(`Invalid input for ${type?.label}: ${value}`);
        return prevRows; // If invalid, do not update the state
      }
      // Update the field with the new value
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
      };
      // If the updated field is 'quantity' or 'unit_value', recalculate 'total_value'
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedRows[index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;
        // Update the total_value in the row
        updatedRows[index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }
      // Return the updated rows after modifying the necessary fields
      return updatedRows;
    });
  };



  const handlequotatationInputChange3 = (name, value, index,type) => {
    // First, update section3Rows
    console.log(section3Rows,index,quotationinputData)
    setSection3Rows(prevRows => {
      const updatedRows = [...prevRows];
      if (!Number.isInteger(index) || index < 0 || index >= updatedRows.length) {
        console.warn(`Invalid row index: ${index}. Defaulting to 0.`);
        index = 0; // Default index to 0 if invalid
      }

      const isValid = validateField(value, type);
      if (!isValid) {
        console.warn(`Invalid input for ${type?.label}: ${value}`);
        return prevRows; // If invalid, do not update the state
      }
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
      };
      // If the 'quantity' or 'unit_value' changed, recalculate total_value
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedRows[index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;
        // Update the total_value in the row
        updatedRows[index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }
      return updatedRows;
    });
    // Then, update quotationinputData
    setQuotationinputData(prevQuotationData => {
      const updatedQuotationData = [...prevQuotationData];

      // Initialize section3Rows for the selectedQuotationId if it doesn't exist
      if (!updatedQuotationData[selectedQuotationId]) {
        updatedQuotationData[selectedQuotationId] = [];
      }

      // Ensure the row exists in quotationData for the current index
      if (!updatedQuotationData[selectedQuotationId][index]) {
        updatedQuotationData[selectedQuotationId][index] = {};
      }


      // Update the specific field in quotationData
      updatedQuotationData[selectedQuotationId][index][name] = value;

      // If the 'quantity' or 'unit_value' changed, recalculate total_value
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedQuotationData[selectedQuotationId][index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;

        // Update the total_value in the row for quotationData
        updatedQuotationData[selectedQuotationId][index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }

      return updatedQuotationData;
    });
  };

  const onSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    setSelectedRow(selectedRows); // Get the first selected row (single selection)

  };


  const handleQuotationChange = (name, value) => {
    setFormData2((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // Update quotationData with the current quotation's edited data
    setQuotationData((prevData) => ({
      ...prevData,
      [selectedQuotationId]: {
        ...prevData[selectedQuotationId],
        [name]: value,
      },
    }));
    console.log("Updated field:",quotations, name, "with value:", value,quotationinputData);
  };



  // Toggle div visibility
  const toggleDiv1 = () => setIsDiv1Open(!isDiv1Open);
  const toggleDiv2 = () => setIsDiv2Open(!isDiv2Open);
  const toggleDiv3 = () => setIsDiv3Open(!isDiv3Open);
  const toggleDiv4 = () => setIsDiv4Open(!isDiv4Open);



  return (
<>
<LoaderComponent loaderOpen={loading} />

<div>
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#0a2352", fontSize: '18px' }}>
        File Reading
      </h2>
    </div>
    <div hidden={unMatchedHidden}>
<Tabs selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}>
        {/* Tab headers */}
<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
  <TabList style={{ display: 'flex' }}>
    {tabConfig.map((tab, i) => (
      <Tab key={i} style={{ width: '150px', textAlign: 'center' }}>
        {tab.title}
      </Tab>
    ))}
  </TabList>
</div>

        {/* Tab content */}
        {tabConfig.map((tab, i) => (
          <TabPanel key={i}>
                    <div
                      className="ag-theme-alpine"
                      style={{
                        overflowX: "auto",
                        overflowY: "auto",
                        borderRadius: "10px",
                        width: `${tablecolumnDefs.length * 225}px`,
                        maxWidth: "100%",
                        height: "543px",
                        paddingTop: "10px",
                      }}
                    >
                      <AgGridReact
                        onGridReady={onGridReady}
                        columnDefs={tablecolumnDefs}
                        rowData={tablerowData}
                        animateRows={true}
                  ref={gridRef}
                        pagination={true}
                        paginationPageSize={11}
                        rowSelection="single"
                        onSelectionChanged={onSelectionChanged}
                  enableCellTextSelection={true}
                  suppressCopyRows={true} 

                      />
                    </div>

                    {/* Action Buttons */}
                    <div className="submit-row">
                      <div>
                        {/* <button className="submit-btn" onClick={handleClick}>
                          VIEW
                        </button> */}
                        <button className="submit-btn" onClick={readFilesService}>
                          Read Folders
                        </button>
                        <button className="submit-btn" onClick={readMailsService}>
                          Read Mails
                        </button>
                        <button className="submit-btn" onClick={processData}>
                          Run
                        </button>
                      </div>

                    </div>
          </TabPanel>
        ))}
      </Tabs>

  </div>
<div hidden={createHidden}>

  <div style={{  textAlign: 'center' }}>

    {/* Navigation Buttons */}

<div style={{ display: 'flex', gap: '10px' }}>
<div style={{ width: "60%" }}>
  <div style={{ marginBottom: "10px" }}>
    <button
      onClick={() => navigate("prev")}
      disabled={currentIndex === 0}
      style={{ marginRight: "10px" }}
    >
      Previous
    </button>

    <button
      onClick={() => navigate("next")}
      disabled={currentIndex === options.length - 1}
    >
      Next
    </button>
  </div>

  {currentFile ? (
    <div style={{ textAlign: "center", marginLeft: "10px" }}>
      {/* ✅ render filename string */}
      <h3>{currentFile}</h3>

      <div
        style={{
          maxWidth: "790px",
          minWidth: "300px",
          height: "620px",
          overflowX: "auto",
          border: "1px solid #ccc",
        }}
      >
        {/* PDF preview */}
        {fileType === "pdf" && (
          <FilePreviewer
            fileType="pdf"
            fileUrl={`http://154.61.75.209:1200/api/v2/user_modules/serve-pdf/${currentFile}`}
            style={{ height: "100%", width: "100%" }}
          />
        )}

        {/* Image preview */}
        {fileType === "image" && (
          <img
            src={`http://154.61.75.209:1200/api/v2/user_modules/serve-file/${currentFile}`}
            alt="Preview"
            style={{ maxWidth: "100%", maxHeight: "500px" }}
          />
        )}

        {/* Unsupported */}
        {fileType === "unsupported" && (
          <h4 style={{ color: "red" }}>Unsupported file type</h4>
        )}
      </div>
    </div>
  ) : (
    <h3>No files to preview</h3>
  )}
</div>


<div style = {{width:'60%'}}>
          <div>
            <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} onSubmit={handleSubmit} />
          </div>
          <div>
            <DynamicForm fields={fields3} formData={formData3} onInputChange={handleInputChange} onSubmit={handleSubmit} />
          </div>
          <div>
            <DynamicForm fields={fields4} formData={formData4} onInputChange={handleInputChange3} onSubmit={handleSubmit} />
          </div>


<div style = {{ marginLeft: "20px", borderRadius: "8px", backgroundColor:'white'}}>
{formData2.length > 0 ? (
  formData2.map((row, index) => (
    <div
      key={index}
      style={{
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "5px", display:"flex", 
      }}
    >

      {/* Horizontal scroll container */}
      <div
        style={{
          maxWidth: "100%",
          overflowX: "auto", display:"flex" ,
          paddingBottom: "5px", // space between fields and scrollbar
        }}
      >

        <div
          style={{
            display: "flex",
            gap: "20px",
            flexWrap: "nowrap",
          }}
        >
          {fields2.map((field, fieldIndex) => {
            if (!field.function) return null;

            return (
              <div
                key={fieldIndex}
                style={{
                  minWidth:
                    field.width.value === "s"
                      ? "15%"
                      : field.width.value === "m"
                      ? "20%"
                      : "30%",
                }}
              >
                <label
                  className="form-label"
                  style={{ display: "block", fontSize: "12px", marginBottom: "4px" }}
                >
                  {field.renameValue || formatColumnName(field.columnName)}:
                </label>

                {field.function === "Input Field" ? (
                  <input
                    type={
                      field.type?.value === "decimal" || field.type?.value === "integer"
                        ? "number"
                        : "text"
                    }

                    name={field.columnName}
                    value={
  field.type?.value === "text"
    ? (row[field.columnName] || "")
    : row[field.columnName] !== undefined && row[field.columnName] !== null
      ? String(row[field.columnName])
      : ""
}


                    onChange={(e) =>
                      handleInputChange2(index, field.columnName, e.target.value, field.type)
                    }
                    className="form-control"
                  />
                ) : (
                  <div
                    className="form-control"
                    style={{ background: "#f5f5f5", minHeight: "30px" }}
                  >
                    {row[field.columnName] || 0.00}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

    </div>
  ))
) : (
  <p>No rows yet. Click + to add one.</p>
)}
</div>

<div style = {{display : "flex",marginLeft:"10px"}} >
      <div>
        <button
          className="submit-btn"
          onClick={handleClick1}
        >
          Back
        </button>
      </div>


</div>


</div>
  </div>
</div>
</div>
</div>
</>
  );
}

export default PurchaseRequirement;